import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { getBochones, getDatos2, getDatos4 } from "../../store/action";
import { url } from "../../URL.js";

function hasValue(v) {
  if (v === null || v === undefined) return false;
  if (typeof v === "string") return v.trim().length > 0;
  if (Array.isArray(v)) return v.length > 0;
  return true;
}

function parseDateSafe(raw) {
  if (!raw || typeof raw !== "string") return null;
  if (raw.includes("-")) {
    const d = new Date(raw);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (raw.includes("/")) {
    const parts = raw.split("/");
    if (parts.length !== 3) return null;
    const [dd, mm, yyyy] = parts.map((x) => Number(x));
    const d = new Date(yyyy, mm - 1, dd);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

export default function OperationalDashboard({ mode = "especimen" }) {
  const dispatch = useDispatch();
  const userD = useSelector((state) => state.usuario);
  const especimenesState = useSelector((state) => state.especimenes);
  const bochonesState = useSelector((state) => state.bochones);
  const [prestamos, setPrestamos] = useState([]);
  const [isPinned, setIsPinned] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (userD?.nivel === 4) {
      dispatch(getDatos4());
    } else {
      dispatch(getDatos2());
    }
    dispatch(getBochones());
    axios
      .get(`${url}prestamosRoute/prestamos`)
      .then((res) => setPrestamos(Array.isArray(res.data) ? res.data : []))
      .catch(() => setPrestamos([]));
  }, [dispatch, userD?.nivel]);

  const kpis = useMemo(() => {
    const especimenes = Array.isArray(especimenesState) ? especimenesState : [];
    const bochones = Array.isArray(bochonesState?.data)
      ? bochonesState.data
      : Array.isArray(bochonesState)
      ? bochonesState
      : [];

    const totalEspecimenes = especimenes.length;
    const totalBochones = bochones.length;

    const bochonesSinAsignar = bochones.filter((b) => {
      const n = b?.especimennumero;
      if (Array.isArray(n)) return n.length === 0;
      return n === 0 || n === "0" || !hasValue(n);
    }).length;

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    const prestamosVencidos = prestamos.filter((p) => {
      if (p?.devuelto) return false;
      const d = parseDateSafe(p?.fechadevolucionest);
      if (!d) return false;
      d.setHours(0, 0, 0, 0);
      return d < hoy;
    }).length;

    const incompletosEspecimen = especimenes.filter((e) => {
      return (
        !hasValue(e?.genero) ||
        !hasValue(e?.especie) ||
        !hasValue(e?.formacion) ||
        !hasValue(e?.descubridor) ||
        !hasValue(e?.localidad)
      );
    }).length;

    const incompletosBochon = bochones.filter((b) => {
      return (
        !hasValue(b?.genero) ||
        !hasValue(b?.especie) ||
        !hasValue(b?.formacion) ||
        !hasValue(b?.descubridor)
      );
    }).length;

    const especimenesEnPreparacion = especimenes.filter(
      (e) => hasValue(e?.url) && String(e.url).toLowerCase() === "si"
    ).length;

    const holotipos = especimenes.filter(
      (e) => String(e?.holotipo).toLowerCase() === "si" || e?.holotipo === true
    ).length;

    return {
      totalEspecimenes,
      totalBochones,
      bochonesAsignados: Math.max(totalBochones - bochonesSinAsignar, 0),
      bochonesSinAsignar,
      prestamosVencidos,
      incompletosEspecimen,
      incompletosBochon,
      especimenesEnPreparacion,
      holotipos,
    };
  }, [bochonesState, especimenesState, prestamos]);

  const isOpen = isPinned || isHovered;

  return (
    <div
      className="operational-dashboard"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button
        type="button"
        className="kpi-toggle"
        onClick={() => setIsPinned((v) => !v)}
      >
        KPIs
      </button>
      <div className={`kpi-popover ${isOpen ? "is-visible" : ""}`}>
        {mode === "bochon" ? (
          <>
            <div className="kpi-row">
              <span>Total bochones</span>
              <strong>{kpis.totalBochones}</strong>
            </div>
            <div className="kpi-row">
              <span>Bochones asignados</span>
              <strong>{kpis.bochonesAsignados}</strong>
            </div>
            <div className="kpi-row">
              <span>Bochones sin asignar</span>
              <strong>{kpis.bochonesSinAsignar}</strong>
            </div>
            <div className="kpi-row kpi-row-alert">
              <span>Bochones incompletos</span>
              <strong>{kpis.incompletosBochon}</strong>
            </div>
            <div className="kpi-row">
              <span>Prestamos vencidos</span>
              <strong>{kpis.prestamosVencidos}</strong>
            </div>
          </>
        ) : (
          <>
            <div className="kpi-row">
              <span>Total especimenes</span>
              <strong>{kpis.totalEspecimenes}</strong>
            </div>
            <div className="kpi-row">
              <span>En preparacion</span>
              <strong>{kpis.especimenesEnPreparacion}</strong>
            </div>
            <div className="kpi-row">
              <span>Holotipos</span>
              <strong>{kpis.holotipos}</strong>
            </div>
            <div className="kpi-row kpi-row-alert">
              <span>Especimenes incompletos</span>
              <strong>{kpis.incompletosEspecimen}</strong>
            </div>
            <div className="kpi-row">
              <span>Prestamos vencidos</span>
              <strong>{kpis.prestamosVencidos}</strong>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
